<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div class="card-header border-0">
        <h5 class="card-title font-bold py-3">گزارش فروش فروشندگان</h5>
        <div style="flex: 1"></div>
        <button @click="print" class="btn btn-primary">
          <span
            style="transform: translateY(3px)"
            class="feather-printer"
          ></span>
        </button>
      </div>
      <div class="row px-4 not-in-print">
        <form @submit.prevent="doFilter" class="d-flex col-12 flex-wrap">
          <b-form-group
            v-if="sellers"
            class="col-xl-6 col-md-12"
            label=" فروشنده :"
          >
            <multiselect
              placeholder="فروشنده را انتخاب کنید"
              v-model="selectedSeller"
              open-direction="bottom"
              :options="sellers"
              label="full_name"
              track-by="id"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              :disabled="disabled"
            >
              <template slot="noOptions"> موردی یافت نشد </template>
              <template slot="noResult"> موردی یافت نشد </template>
            </multiselect>
          </b-form-group>

          <div class="col-xl-6 col-md-12 d-flex">
            <div class="col-6 d-flex">
              <b-form-group label="از تاریخ :">
                <date-picker
                  type="datetime"
                  v-model="startDate"
                  :format="'YYYY-MM-DD HH:mm'"
                  :display-format="'jYYYY-jMM-jDD HH:mm'"
                />
              </b-form-group>
            </div>
            <div class="col-6 d-flex">
              <b-form-group label="تا تاریخ :">
                <date-picker
                  type="datetime"
                  v-model="endDate"
                  :format="'YYYY-MM-DD HH:mm'"
                  :display-format="'jYYYY-jMM-jDD HH:mm'"
                />
              </b-form-group>
            </div>
          </div>
          <div class="col-12 d-flex justify-content-end" style="gap: 8px">
            <button :disabled="disabled" type="submit" class="btn btn-primary">
              فیلتر
            </button>
            <button
              @click="resetFilter"
              :disabled="disabled"
              type="submit"
              class="btn btn-warning"
            >
              برداشتن فیلتر
            </button>
          </div>
        </form>
      </div>
      <div id="print" class="p-4">
        <div
          class="d-flex mb-3 mr-2-print print-justify-center"
          style="gap: 16px"
          v-if="startDate || endDate"
        >
          <strong class="show-in-print">گزارش فروش حضوری </strong>
          <div v-if="startDate">
            <span> از تاریخ</span><span> {{ startDate | persianDate }} </span>
          </div>
          <div class="mr-4" v-if="endDate">
            <span> تا تاریخ</span><span> {{ endDate | persianDate }} </span>
          </div>
        </div>
      </div>
      <div id="print" class="p-4">
        <b-table
          id="main-table"
          v-if="reports"
          bordered
          striped
          :fields="fields"
          :items="reports"
          responsive="sm"
        >
          <template #cell(index)="data">
            {{ data.index + 1 }}
          </template>
          <template v-slot:cell(amount)="data">
            {{ data.item.amount | price }}
          </template>
          <template v-slot:cell(factor_id)="data">
            <router-link  
                :to="`/admin/shop/orders/${data.item.factor_id}`"  
                class="btn btn-primary"  
              >{{ data.item.factor_id }}</router-link>  
          </template>
          <template v-slot:cell(cashier_name)="data">
            {{ data.item.cashier_name.name }}
          </template>
          <template #bottom-row="data">
            <b-td colspan="5">
              <div class="text-center">جمع کل</div>
            </b-td>
            <b-td>
             {{ totals.quantity | price }}
            </b-td>
            <b-td>
             {{ totals.amount | price }} تومان</b-td
            >
            <b-td>*</b-td>
          </template>
          <template v-slot:cell(detail)="data">
            <b-button @click="showDetail(data.item)" variant="primary">
              <i class="fa fa-eye"></i>
            </b-button>
          </template>
        </b-table>
        <table v-if="totals" class="d-flex justify-content-between"></table>
        <ShowVarietiesModal
          :product-id="showVarietiesProductId"
          :report-code="reportCode"
        />
        <div v-if="reportsLoading" class="alert alert-primary">
          در حال بارگزاری
        </div>
      </div>

      <div class="d-flex flex-column w-100">
        <!--        <div>-->
        <!--          <div class="d-flex">-->
        <!--            <div class="p-5" style="border: 1px solid" v-for="field in fields">-->
        <!--              {{ field.label }}-->
        <!--            </div>-->
        <!--          </div>-->
        <!--          <div class="d-flex w-100" v-for="item in reports">-->
        <!--            <div class="p-5" style="border: 1px solid" v-for="field in fields">-->
        <!--              {{ item[field.key] }}-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
    </div>
    <b-modal
      id="order-detial"
      hide-footer
      :title="`مشاهده جزئیات ${selectedItem ? selectedItem.product_title : ''}`"
    >
      <b-table
        v-if="selectedItem"
        :fields="fields2"
        :items="selectedItem.mini_order_items"
      >
        <template #cell(index)="data">
          {{ data.index + 1 }}
        </template>
        <template v-slot:cell(change)="data">
          <multiselect
            placeholder="فروشنده را انتخاب کنید"
            v-model="selectedSellerList[data.index]"
            open-direction="bottom"
            :options="sellers"
            label="full_name"
            track-by="id"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            :disabled="disabled"
          >
            <template slot="noOptions"> موردی یافت نشد </template>
            <template slot="noResult"> موردی یافت نشد </template>
          </multiselect>
        </template>
        <template v-slot:cell(submit)="data">
          <b-button
            :disabled="disabledBtn"
            @click="changeSeller(data.index, data.item.mini_order_item_id)"
          >
            ثبت
          </b-button>
        </template>
      </b-table>
    </b-modal>
  </main>
</template>

<script>
import {
  BTable,
  BFormGroup,
  BFormInput,
  BTr,
  BTd,
  BButton,
  BModal,
} from "bootstrap-vue";
import DatePickerRange from "@@/core/components/shared/DatePickerRange/DatePickerRange";
import ShowVarietiesModal from "@@/core/components/report/ShowVarietiesModal";
import Dropdown from "@@/core/components/shared/Dropdown/Dropdown";
import configProvider from "@@/core/configProvider";
import reportMixin from "@@/core/mixins/reportMixin";
import ProductSearch from "@@/core/components/shared/ProductSearch/ProductSearch";

export default {
  name: "ProductsReport",
  components: {
    Dropdown,
    ShowVarietiesModal,
    DatePickerRange,
    BTable,
    BFormGroup,
    BFormInput,
    BTr,
    BTd,
    BButton,
    BModal,
    ProductSearch,
  },
  configProvider,
  data() {
    return {
      selectedItem: null,
      selectedSellerList: [],
      sellers: null,
      selectedSeller: null,
      reportsLoading: false,
      disabledBtn: false,
      selectedProduct: null,
      selectedVariety: null,
      disabled: false,
      totals: null,
      index: 1,
      fields: [
        {
          key: "index",
          label: " ردیف",
        },
        {
          key: "factor_id",
          label: "شماره فاکتور",
        },
        {
          key: "product_title",
          label: "عنوان محصول",
        },
        {
          key: "cashier_name",
          label: "صندوق دار",
        },
        {
          key: "seller_name",
          label: "فروشنده",
        },
        {
          key: "quantity",
          label: "تعداد",
        },
        {
          key: "amount",
          label: "مبلغ(تومان)",
        },
        {
          key: "created_at",
          label: "تاریخ",
        },
      ],
      endDate: null,
      startDate: null,
      productsList: [{ status: true }],
      page: 1,
      reports: null,
      sortBy: null,
      sortDesc: null,

      showVarietiesProductId: null,
    };
  },
  mixins: [reportMixin],
  mounted() {
    this.loadData();
  },
  methods: {
    resetFilter() {
      this.type = { id: "sell", label: "فروش" };
      this.endDate = null;
      this.startDate = null;
      this.productsList = [{ status: true }];
    },
    handlerItem(content) {
      if (typeof content == "string") {
        this.productsList.push({ status: true });
        this.$forceUpdate();
      } else {
        this.productsList[content].status = false;
        this.$forceUpdate();
      }
    },
    selectTheVariety(e) {
      this.selectedVariety = e;
      if (e.rowIndex != null) {
        this.productsList[e.rowIndex].variety = e;
      }
    },
    selectTheProduct(e) {
      console.log(e);
      this.selectedProduct = e;
    },
    print() {
      print();
    },

    doFilter() {
      this.loadData();
    },
    changePage(page = 1) {
      this.previousPage = this.page;
      this.page = page;
      this.loadData();
    },
    async loadData() {
      try {
        const today = new Date();  
        const startOfToday = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);  

        function formatDate(date) {  
          const year = date.getFullYear();  
          const month = String(date.getMonth() + 1).padStart(2, '0');  
          const day = String(date.getDate()).padStart(2, '0');  
          const hours = String(date.getHours()).padStart(2, '0');  
          const minutes = String(date.getMinutes()).padStart(2, '0');  
          const seconds = String(date.getSeconds()).padStart(2, '0');  

          return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;  
        }  
        if (!this.startDate || !this.endDate) {  
            this.startDate = formatDate(startOfToday);  
            this.endDate = formatDate(today);  
        }  
        this.disabled = true;
        this.reportsLoading = true;
        let selectedVariety = [];
        this.productsList
          .filter((item) => item.status)
          .forEach((item) => {
            if (item.variety) selectedVariety.push(item.variety.id);
          });
        const response = await this.$axios.get(
          "admin/reports/sellers-new",
          {
            params: {
              start_date: this.startDate,
              end_date: this.endDate,
              seller_id: this.selectedSeller ? this.selectedSeller.id : null,
            },
          }
        );
        this.sellers = response.data.data.sellers;
        this.reports = response.data.data.reports;
        this.totals = response.data.data.totals;
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
        this.reportsLoading = false;
      }
    },
    showDetail(item) {
      this.selectedItem = item;
      this.selectedSellerList = [];
      item.mini_order_items.forEach((i) => {
        this.selectedSellerList.push(
          this.sellers.find((seller) => {
            return seller.id == i.seller_id;
          })
        );
      });
      this.$root.$emit("bv::show::modal", "order-detial");
    },
    changeSeller(index, id) {
      this.disabledBtn = true;
      let fd = new FormData();
      fd.append("seller_id", this.selectedSellerList[index].id);
      fd.append("_method", "PUT");
      this.$axios
        .post(`admin/accounting/seller_report/change_seller/${id}`, fd)
        .then((res) => {
          this.disabledBtn = false;
          this.$root.notify(res.data.message, "success");
          this.loadData();
        })
        .catch((err) => {
          this.disabledBtn = false;
          this.$root.notify(err);
        });
    },
    showVarieties(productId) {
      this.$root.$emit("bv::show::modal", "show-order-detial");
      this.showVarietiesProductId = productId;
    },
  },
};
</script>

<style>
.print-only {
  display: none;
}
.show-in-print {
  display: none;
}
@media print {
  .show-in-print {
    display: block;
  }
  .not-in-print {
    display: none !important;
  }
  .print-justify-center {
    justify-content: center;
  }
  .app-content .side-app {
    padding: 0 !important;
  }

  .print-only {
    display: block !important;
  }

  body * {
    visibility: hidden;
  }
  #print,
  #print * {
    visibility: visible;
    font-size: 1.25rem;
  }
  #print {
    padding: 0 !important;
  }
  #print {
    width: 100%;
  }

  #print .not-in-print {
    display: none;
  }

  .mr-2-print {
    margin-right: 20px;
  }
}
</style>
